import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div>
          <Logo onClick={() => navigate("/")} testid="footer-logo" />
          <p className="footer-copy">idevorai © 2026 — Le labo des business qui rapportent.</p>
        </div>
        <div className="footer-links">
          <button onClick={() => navigate("/tarifs")} data-testid="footer-tarifs">Tarifs</button>
          <button onClick={() => navigate("/compte")} data-testid="footer-compte">Mon compte</button>
          <button onClick={() => navigate("/aide#contact")} data-testid="footer-contact">Contact</button>
          <button onClick={() => navigate("/cgv")} data-testid="footer-cgv">CGV</button>
          <button onClick={() => navigate("/remboursement")} data-testid="footer-remboursement">Remboursement</button>
          <button onClick={() => navigate("/mentions-legales")} data-testid="footer-mentions">Mentions légales</button>
        </div>
      </div>
    </footer>
  );
};
